export function ForumBackground() {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
      {/* Purple circle */}
      <div className="absolute top-20 right-[10%] w-64 h-64 rounded-full bg-purple-900/20 blur-3xl" />

      {/* Pink blob */}
      <div className="absolute bottom-20 left-[5%] w-72 h-72 rounded-full bg-pink-900/10 blur-3xl" />

      {/* Blue circle */}
      <div className="absolute top-[40%] left-[20%] w-48 h-48 rounded-full bg-blue-900/10 blur-3xl" />

      {/* Yellow accent */}
      <div className="absolute bottom-[30%] right-[15%] w-56 h-56 rounded-full bg-amber-900/10 blur-3xl" />

      {/* SVG Patterns */}
      <svg className="absolute top-0 left-0 w-full h-full opacity-[0.05]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
          <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
            <rect width="80" height="80" fill="url(#smallGrid)" />
            <path d="M 80 0 L 0 0 0 80" fill="none" stroke="white" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>

      {/* Dots pattern */}
      <svg className="absolute top-0 right-0 w-full h-full opacity-[0.03]" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="dots" width="30" height="30" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="white" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dots)" />
      </svg>
    </div>
  )
}
